import type { ApiConfig } from '../../types'

/**
 * Backpack の利息支払い履歴 API 設定。
 * `/wapi/v1/history/interest` (instruction: interestHistoryQueryAll) を利用する。
 * Lend の受取利息と Futures unrealized PnL に対する利息を対象とする。
 * 借入利息 (Borrow / EntryFee) は借入元本に組み入れられ、`borrow-lend-history` の返済時に計上されるため対象外。
 *
 * 本 endpoint は `from` / `to` フィルタをサポートせず、offset ベースの pagination のみ。
 * このため `fetchApiData` 内部で全ページを取得する設計とし、 `limit` には framework の
 * "count < limit ⇒ 全取得済" 判定が常に成立する大きな値を設定する。
 */
export const interestHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1_000_000,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'interest-history',
} as const satisfies ApiConfig
